import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface Subsidiary {
    active: boolean;
    companyId: string;
    createdAt: any;
    description: string;
    name: string;
    updatedAt: any;
}

interface SubsidiaryId extends Subsidiary {
    id: string;
}

@Injectable()
export class SubsidiaryService {

    subsidiaryCollection: AngularFirestoreCollection<Subsidiary>;
    subsidiaries: any;

    subsidiaryDocument: AngularFirestoreDocument<SubsidiaryId>;
    subsidiary: Observable<SubsidiaryId>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.SUBSIDIARY_COLLECTION;
    }

    postSubsidiary(subsidiaryObject: any) {
        this.subsidiaryCollection = this.afs.collection(this.collection);

        return this.subsidiaryCollection.add({...subsidiaryObject, active: true}).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getSubsidiaries() {
        this.subsidiaryCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', true) );

        this.subsidiaries = this.subsidiaryCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Subsidiary;

                const name = data.name;
                const description = data.description;

                return { id$, name, description };
            });
        }).map(object => object);

        return this.subsidiaries;
    }

    getSubsidiary(id$: string) {
        this.subsidiaryDocument = this.afs.doc(this.collection + '/' + id$);

        this.subsidiary = this.subsidiaryDocument.valueChanges();

        return this.subsidiary.map(object => object);
    }

    putSubsidiary(subsidiaryObject: any, id$: string) {
        this.subsidiaryCollection = this.afs.collection(this.collection);

        return this.subsidiaryCollection.doc(id$).update({...subsidiaryObject, active: true}).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    delSubsidiary(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.subsidiaryDocument = this.afs.doc(this.collection + '/' + id$);

        return this.subsidiaryDocument.update({active: false});
    }

}
